export const countryISOCodeByCountry = {
  de: 'de',
  en: 'gb',
  rs: 'rs',
  ru: 'ru',
  es: 'es',
  fr: 'fr'
};
